export const ROLES = ["ev", "le", "pm", "ma", "ca"] as const;

export type Role = (typeof ROLES)[number];

export type Permission =
  | "page:home"
  | "page:evidence"
  | "page:issue"
  | "page:organization"
  | "page:users"
  | "page:ai_diagnostic"
  | "page:report"
  | "page:projects"
  | "page:standards"
  | "card:recent_avi"
  | "card:deadline"
  | "card:workflow"
  | "card:avi_list"
  | "card:team_overview"
  | "card:project_overview"
  | "panel:avi"
  | "panel:projects";
